import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function PurifierTable({ data, onEdit }) {
  const columns = [
    {
      title: "Purifier Title",
      dataIndex: "title",
      key: "title",
      align: "center",
    },
    {
      title: "Purifier Make",
      dataIndex: "purifier_make",
      key: "purifier_make",
      align: "center",
    },
    {
      title: "Purifier Model",
      dataIndex: "purifie_model",
      key: "purifie_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
